import { gql } from '@apollo/client';

export const UPDATE_ONLINE_BOOKING_ENABLED = gql`
  mutation updateOnlineBookingEnabled($id: Int!, $input: HostInput!) {
    updateHost(id: $id, input: $input) {
      id
      online_booking_enabled
    }
  }
`;
